import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';

const SELECTED_MESSAGES_LIMIT = 9;

export function selectMessage(groupId: string, messageId: string): void {
  const group = Entities.GroupsStore.getGroupById(groupId);
  const messagesStore = group?.messagesStore;

  if (!messagesStore) {
    return;
  }

  const message = messagesStore.getMessageById(messageId);

  if (!message) {
    return;
  }

  if (
    !message.isSelected &&
    messagesStore.multiSelect.selectedMessagesIds.size > SELECTED_MESSAGES_LIMIT
  ) {
    Tasks.app.showAlert(t('multiselect_limit_exceeded'));

    return;
  }

  if (message.isSelected) {
    messagesStore.multiSelect.unselectMessage(message.id);
  } else {
    messagesStore.multiSelect.selectMessage(message.id);
  }
}
